import { MERCHANT } from "constants/action-types";
import { IMerchantPreference, updateableMerchantPreferenceFields } from "constants/merchant";
import { FluxStandardAction as Action } from "flux-standard-action";

export type GetMerchantPreferenceRequestAction = Action<
    {
        merchantId: string;
    },
    {}
>;
export const getMerchantPreferenceRequest = (merchantId: string): GetMerchantPreferenceRequestAction => ({
    meta: {},
    payload: { merchantId },
    type: MERCHANT.PREFERENCE.GET.REQUEST,
});

export type GetMerchantPreferenceCompleteAction = Action<IMerchantPreference | Error, {}>;
export const getMerchantPreferenceComplete = (
    payload: IMerchantPreference | Error,
): GetMerchantPreferenceCompleteAction => ({
    meta: {},
    payload,
    error: payload instanceof Error,
    type: MERCHANT.PREFERENCE.GET.COMPLETE,
});

export interface IUpdateMerchantPreference
    extends Partial<Pick<IMerchantPreference, keyof typeof updateableMerchantPreferenceFields>> {}
export type UpdateMerchantPreferenceRequestAction = Action<
    {
        merchantId: string;
        preference: IUpdateMerchantPreference;
    },
    {}
>;
export const updateMerchantPreferenceRequest = (
    merchantId: string,
    preference: IUpdateMerchantPreference,
): UpdateMerchantPreferenceRequestAction => ({
    meta: {},
    payload: { merchantId, preference },
    type: MERCHANT.PREFERENCE.UPDATE.REQUEST,
});
